import Vue from "vue";
import Vuex from "vuex";
import housing from "./housing";
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    housing: housing
  }
});